import { Grid } from '@ts/storybook';
import WrapperEntitySelector from '@modules/entitySelector/WrapperEntitySelector';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { IForm, TMode } from '@ts/ui-models';
import { Typography } from '@ts/storybook';

interface IOrgACLFormProps extends IForm {}

const OrganizationAclForm = (props: IOrgACLFormProps) => {
  const { values, requiredFields, onChange, mode } = props;
  const isViewMode = mode === 'view';

  //#region Handlers
  const onChangeEntitySelector = (entity, entityName, fkField) => {
    const value = entity ? entity.getID() : null;
    onChange(entityName, entity);
    onChange(fkField, value);
  };

  //#endregion

  return (
    <Grid container spacing={2}>
      <WrapperEntitySelector
        label="User"
        value={values.userId}
        onChangeEntity={v => onChangeEntitySelector(v, 'user', 'userId')}
        searchComponent={generateSearchEntitySelector('user')}
        required={requiredFields.includes('userId')}
        isReadOnly={isViewMode}
      />
      <WrapperEntitySelector
        label="Role"
        value={values.role}
        onChangeEntity={v => onChangeEntitySelector(v, 'role', 'roleId')}
        searchComponent={generateSearchEntitySelector('role')}
        required={requiredFields.includes('roleId')}
        isReadOnly={isViewMode}
      />
      <br />
      <Typography
        variant="body1"
        text={[<i>Please reload (F5) the application in order to have new roles available once they are added to the user</i>]}
      />
    </Grid>
  );
};

export default OrganizationAclForm;
